module.exports = __webpack_public_path__ + "img/socks.e7455f15.png";